export async function initSentry() {
  if (import.meta.env.DEV) return; // lokalde event gönderme

  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: "https://e108bffa3f930bb5903f331013c644ed@o4511552738689024.ingest.de.sentry.io/4511552882409552",
    environment: "production",
    tracesSampleRate: 0.2,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
    ],
  });
}
